import React from 'react';
import { FormattedMessage, injectIntl} from 'react-intl';
import { Input, Modal, Radio, Select, Spin, Switch } from 'antd';
import './CmmaDevice.less';

const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

//会议室管理
class CmmaDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, CmmaDevice.defaultState, { loading: false });
  }

  componentWillReceiveProps(props) {
    const { cmmaDeviceInfo } = props;
    this.setState({ ...cmmaDeviceInfo });
  }

  save = () => {
    const { dispatch, intl } = this.props;
    const { name, cucmName, primaryAddress } = this.state;
    let checkResult = '';
    if (!name || name === '') {
      checkResult = intl.formatMessage({id: "device_modal_name_required"});
    } else if (name.length < 3) {
      checkResult = intl.formatMessage({id: "device_modal_name_less"});
    } else if (name.length > 50) {
      checkResult = intl.formatMessage({id: "device_modal_name_more"});
    } else if (!cucmName || cucmName === '') {
      checkResult = intl.formatMessage({id: "device_modal_cucmname_required"});
    } else if (cucmName.length > 50) {
      checkResult = intl.formatMessage({id: "device_modal_cucmname_more"});
    } else if (!primaryAddress || primaryAddress === '') {
      checkResult = intl.formatMessage({id: "device_modal_primaryAddress_required"});
    }

    if (checkResult !== '') {
      Modal.error({
        title: checkResult,
        okText: intl.formatMessage({id: 'dialog_btn_ok'})
      });
      return;
    }

    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/synCmmaDevice',
        resolve,
        reject,
        payload: this.state
      });
    });
    promise.then(
      () => {
        Modal.success({ content: intl.formatMessage({id: "room_manage_video_bind_suc"}) });
      },
      () => {
        Modal.error({ content: intl.formatMessage({id: "room_manage_video_bind_fail"}) });
      }
    );
  };

  render() {
    const {
      show, intl,
      cancelHandle,
      deleteHandle,
      cmmaDeviceInfo: { cmmaRoomId, cmmaDeviceId }
    } = this.props;
    const BiTianDiv = (
      <div className="bitian_div">
        <span className="bitian_span">*</span>
      </div>
    );

    return (
      <Modal
        wrapClassName="cmma_device_modal modal-close-header"
        visible={show}
        footer={null}
        title={intl.formatMessage({id: "room_manage_video_bind"})}
        onCancel={() => {
          this.setState(Object.assign({}, CmmaDevice.defaultState));
          cancelHandle();
        }}
        width={600}
      >
        <Spin spinning={this.state.loading}>
          <div className="room_editor_content">
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_name"/>
              </div>
              <div className="right">
                <Input
                  type="text"
                  maxLength="50"
                  value={this.state.name}
                  onChange={e => {
                    this.setState({ name: e.target.value });
                  }}
                  placeholder={intl.formatMessage({id: 'device_modal_name_ph'})}
                />
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_cucmname"/>
              </div>
              <div className="right">
                <Input
                  type="text"
                  maxLength="50"
                  value={this.state.cucmName}
                  onChange={e => {
                    this.setState({ cucmName: e.target.value });
                  }}
                  placeholder={intl.formatMessage({id: "device_modal_cucmname_ph"})}
                />
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_model"/>
              </div>
              <div className="right">
                <div className="room_category_sel">
                  <Select
                    value={`${this.state.model}`}
                    onChange={value => {
                      this.setState({ model: value });
                    }}
                  >
                    <Option value="sx10">SX10</Option>
                    <Option value="sx20">SX20</Option>
                    <Option value="sx80">SX80</Option>
                    <Option value="cisco"><FormattedMessage id="device_modal_item_ciscoOther"/></Option>
                    <Option value="thirdparty"><FormattedMessage id="device_modal_item_thirdPart"/></Option>
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_primaryAddress"/>
              </div>
              <div className="right">
                <Input
                  type="text"
                  maxLength="50"
                  value={this.state.primaryAddress}
                  onChange={e => {
                    this.setState({ primaryAddress: e.target.value });
                  }}
                  placeholder={intl.formatMessage({id: 'device_modal_primaryAddress_ph'})}
                />
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_protocol"/>
              </div>
              <div className="right">
                <div className="room_category_sel">
                  <Select
                    value={`${this.state.protocol}`}
                    onChange={value => {
                      this.setState({ protocol: value });
                    }}
                  >
                    <Option value="sip">SIP</Option>
                    <Option value="h323">H323</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_sipEncryption"/>
              </div>
              <div className="right">
                <div className="room_category_radio">
                  <RadioGroup
                    value={this.state.sipEncryption}
                    onChange={e => {
                      this.setState({ sipEncryption: e.target.value });
                    }}
                  >
                    <RadioButton value="required"><FormattedMessage id="device_modal_item_required"/></RadioButton>
                    <RadioButton value="optional"><FormattedMessage id="device_modal_item_optional"/></RadioButton>
                    <RadioButton value="prohibited"><FormattedMessage id="device_modal_item_prohibited"/></RadioButton>
                  </RadioGroup>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_bandWidth"/>
              </div>
              <div className="right">
                <div className="room_category_sel">
                  <Select
                    value={`${this.state.bandWidth}`}
                    onChange={value => {
                      this.setState({ bandWidth: value });
                    }}
                  >
                    <Option value="0"><FormattedMessage id="device_modal_item_unlimited"/></Option>
                    <Option value="500000">0.5Mb/S</Option>
                    <Option value="1000000">1 Mb/S</Option>
                    <Option value="1500000">1.5Mb/S</Option>
                    <Option value="2000000">2 Mb/S</Option>
                    <Option value="3000000">3 Mb/S</Option>
                    <Option value="4000000">4 Mb/S</Option>
                    <Option value="6000000">6 Mb/S</Option>
                    <Option value="8000000">8 Mb/S</Option>
                    <Option value="10000000">10 Mb/S</Option>
                    <Option value="12000000">12 Mb/S</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_qualityMains"/>
              </div>
              <div className="right">
                <div className="room_category_sel">
                  <Select
                    value={`${this.state.qualityMains}`}
                    onChange={value => {
                      this.setState({ qualityMains: value });
                    }}
                  >
                    <Option value="unrestricted"><FormattedMessage id="device_modal_item_unlimited"/></Option>
                    <Option value="max1080p30">max1080p30</Option>
                    <Option value="max720p30">max720p30</Option>
                    <Option value="max480p30">max480p30</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_qualityPresentation"/>
              </div>
              <div className="right">
                <div className="room_category_sel">
                  <Select
                    value={`${this.state.qualityPresentation}`}
                    onChange={value => {
                      this.setState({ qualityPresentation: value });
                    }}
                  >
                    <Option value="unrestricted"><FormattedMessage id="device_modal_item_unlimited"/></Option>
                    <Option value="max1080p30">max1080p30</Option>
                    <Option value="max720p5">max720p30</Option>
                  </Select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                TIP :
              </div>
              <div className="right">
                <div className="sign_type_sel">
                  <Switch
                    checked={this.state.tip === 1}
                    onChange={checked => {
                      this.setState({ tip: checked ? 1 : 0 });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_sendDouble"/>
              </div>
              <div className="right">
                <div className="sign_type_sel">
                  <Switch
                    checked={this.state.sendDouble === 1}
                    onChange={checked => {
                      this.setState({ sendDouble: checked ? 1 : 0 });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_dualStreamMode"/>
              </div>
              <div className="right">
                <div className="room_category_radio">
                  <RadioGroup
                    value={this.state.dualStreamMode}
                    onChange={e => {
                      this.setState({ dualStreamMode: e.target.value });
                    }}
                  >
                    <Radio value="dualStream"><FormattedMessage id="device_modal_item_dualStream"/></Radio>
                    <Radio value="singleStream"><FormattedMessage id="device_modal_item_singleStream"/></Radio>
                  </RadioGroup>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="left">
                {BiTianDiv}
                <FormattedMessage id="device_modal_bfcp"/>
              </div>
              <div className="right">
                <div className="room_category_radio">
                  <RadioGroup
                    value={this.state.bfcpMode}
                    onChange={e => {
                      this.setState({ bfcpMode: e.target.value });
                    }}
                  >
                    <Radio value="serverAndClient"><FormattedMessage id="device_modal_item_sandc"/></Radio>
                    <Radio value="serverOnly"><FormattedMessage id="device_modal_item_server"/></Radio>
                  </RadioGroup>
                </div>
              </div>
            </div>
          </div>
          <div className="cmma_device_modal_footer">
            {cmmaDeviceId > -1 && (
              <div
                className="device_button_delete"
                onClick={() => {
                  this.setState(Object.assign({}, CmmaDevice.defaultState));
                  deleteHandle(cmmaRoomId);
                }}
              >
                <FormattedMessage id="device_modal_delete"/>
              </div>
            )}
            <div
              className="device_button_cancel"
              onClick={() => {
                this.setState(Object.assign({}, CmmaDevice.defaultState));
                cancelHandle();
              }}
            >
              <FormattedMessage id="device_modal_cancel"/>
            </div>
            <div className="device_button_ok" onClick={this.save}>
              <FormattedMessage id="mc_btn_ok"/>
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }
}

export default injectIntl(CmmaDevice);

CmmaDevice.defaultState = {
  id: 0,
  cmmaRoomId: -1,
  cmmaDeviceId: -1,
  name: '',
  cucmName: '',
  model: 'sx10',
  primaryAddress: '',
  protocol: 'sip',
  sipEncryption: 'prohibited',
  bandWidth: '0',
  qualityMains: 'unrestricted',
  qualityPresentation: 'unrestricted',
  tip: 0,
  sendDouble: 1,
  dualStreamMode: 'dualStream',
  bfcpMode: 'serverAndClient'
};



// WEBPACK FOOTER //
// ./src/components/account/CmmaDevice.js